import CssBaseline from '@mui/material/CssBaseline';
import { Routes, Route, Navigate } from 'react-router';
import { Suspense, lazy } from 'react';
import { routes } from './constants/routes';
import AppLoader from './components/common/AppLoader';
import { DashboardProvider } from './Providers/DashboardProvider';
import RestaurantMenuConfig from './pages/knowledgeBase/RestaurantMenuConfig';

const Reservation = lazy(() => import('./pages/knowledgeBase/Reservation'));
import OrderManagmentPage from './pages/order-managment/OrderManagmentpage';
import SignUpJourney from './pages/Auth/SignupJourney.tsx/SignUpJourney';
import VerifyMail from './pages/VerifyMail';
import AcceptInvite from './pages/AcceptInvite';
import { Billing } from './pages';
import ReservationManagement from './pages/ReservationManagement';
import AddNewAssistant from './pages/AddNewAssistant';
import SetUpBusiness from './pages/SetUpBusiness';
import AddNewAssistantTemplate from './pages/AddNewAssistantTemplate';
import AgentCreationWizardPage from './pages/AgentCreationWizard';
import BusinessSetupWizard from './components/UserJourny/UnifiedWizard/BusinessSetupWizard';
import AgentCreationWizard from './components/UserJourny/UnifiedWizard/AgentCreationWizard';
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
// const CallsPage = lazy(() => import('./pages/Calls/CallsPage'));
import CallsPage from './pages/Calls/CallsPage';
const WhatsAppLogs = lazy(() => import('./pages/WhatsappLogs/WhatsappLogs'));
const ManageUsers = lazy(() => import('./pages/ManageUsers'));
const VoiceLibrary = lazy(() => import('./pages/VoiceLibrary'));
// const KnowledgeBase = lazy(() => import('./pages/KnowledgeBase'));
// const PhoneNumbers = lazy(() => import('./pages/PhoneNumbers'));
import PhoneNumbers from './pages/PhoneNumbers';
import AgentsScreen from './pages/Dashboard/AgentsScreen';
import CallDetails from './pages/Calls/CallDetails';
import GeneralSupportList from './pages/knowledgeBase/GeneralSupportList';
import BrandManagment from './pages/BrandManagment/BrandManagment';
import WhatsappLogs from './pages/WhatsappLogs/WhatsappLogs';
import WhatsappChatsPge from './pages/WhatsappLogs/WhatsappChatsPage';
import PromptCompare from './pages/PromptCompare';
import GlobalCallManager from './components/common/GlobalCallManager';
import CallStagesFlow from './pages/Dashboard/CallStagesFlow';
import UserProfile from './pages/UserProfile';
import WindmillFlows from './pages/Windmill/WindmillFlows';
import FlowDetail from './pages/Windmill/FlowDetail';
import JobDetail from './pages/Windmill/JobDetail';
const Analytics = lazy(() => import('./pages/Analytics/AnalyticsLayout'));
const AgentAnalytics = lazy(() => import('./pages/Analytics/AgentAnalytics'));
const CallAudits = lazy(() => import('./pages/Analytics/CallAudits'));
const CallEvaluation = lazy(() => import('./pages/Analytics/CallEvaluation'));
const StoreManagement = lazy(
  () => import('./pages/Store-managment/StoreManagement')
);
const CustomerManagement = lazy(
  () => import('./pages/Customer-Management/CustomerManagement')
);
const CampaignPage = lazy(() => import('./pages/Campaign/CampaignPage'));
const IntegrationsPage = lazy(
  () => import('./pages/Integrations/IntegrationsPage')
);

const ProtectedRoute = lazy(() => import('./components/Auth/ProtectedRoutes'));
const PublicRoute = lazy(() => import('./components/Auth/PublicRoutes'));
const SignIn = lazy(() => import('./pages/Auth/SignIn'));
const ResetPassword = lazy(() => import('./pages/Auth/ResetPassword'));
import RouteNotFound from './components/common/RouteNotFound';

export default function App() {
  return (
    <>
      <CssBaseline />
      <Suspense fallback={<AppLoader />}>
        <DashboardProvider>
          <Routes>
            <Route
              path={routes.analytics}
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              }
            >
              <Route
                index
                element={
                  <Navigate
                    to={`${routes.analytics}/${routes.agentAnalytics}`}
                    replace
                  />
                }
              />
              <Route
                path={routes.agentAnalytics}
                element={<AgentAnalytics />}
              />
              <Route
                path={routes.callEvaluation}
                element={<CallEvaluation />}
              />
            </Route>
            <Route
              path={`${routes.analytics}/${routes.callAuditing}`}
              element={
                <ProtectedRoute>
                  <CallAudits />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.agent}
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.addNewAssistant}
              element={
                <ProtectedRoute>
                  <AddNewAssistant />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.agentCreation}
              element={
                <ProtectedRoute>
                  <AgentCreationWizardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.setUpBusiness}
              element={
                <ProtectedRoute>
                  <SetUpBusiness />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.onboarding}
              element={
                <ProtectedRoute>
                  <BusinessSetupWizard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/onboarding/agent"
              element={
                <ProtectedRoute>
                  <AgentCreationWizard />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.addNewAssistantTemplate}
              element={<AddNewAssistantTemplate />}
            />
            <Route
              path={routes.storeManagement}
              element={
                <ProtectedRoute>
                  <StoreManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.reservationManagement}
              element={
                <ProtectedRoute>
                  <ReservationManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.billing}
              element={
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.calls}
              element={
                <ProtectedRoute>
                  <CallsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.call}
              element={
                <ProtectedRoute>
                  <CallDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.whatsAppLogs}
              element={
                <ProtectedRoute>
                  <WhatsAppLogs />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.manageUsers}
              element={
                <ProtectedRoute>
                  <ManageUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.voiceLibrary}
              element={
                <ProtectedRoute>
                  <VoiceLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.agents}
              element={
                <ProtectedRoute>
                  <AgentsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.restaurantMenuConfig}
              element={
                <ProtectedRoute>
                  <RestaurantMenuConfig />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.generalSupport}
              element={
                <ProtectedRoute>
                  <GeneralSupportList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.reservation}
              element={
                <ProtectedRoute>
                  <Reservation />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.whatsappChats}
              element={
                <ProtectedRoute>
                  <WhatsappLogs />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.promptCompare}
              element={
                <ProtectedRoute>
                  <PromptCompare />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.whatsappChatByPhone}
              element={
                <ProtectedRoute>
                  <WhatsappChatsPge />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.brandManagement}
              element={
                <ProtectedRoute>
                  <BrandManagment />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.customerManagement}
              element={
                <ProtectedRoute>
                  <CustomerManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.orderManagment}
              element={
                <ProtectedRoute>
                  <OrderManagmentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.campaign}
              element={
                <ProtectedRoute>
                  <CampaignPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.integration}
              element={
                <ProtectedRoute>
                  <IntegrationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.phoneNumber}
              element={
                <ProtectedRoute>
                  <PhoneNumbers />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.login}
              element={
                <PublicRoute>
                  <SignIn />
                </PublicRoute>
              }
            />
            <Route
              path={routes.signup}
              element={
                <PublicRoute>
                  <SignUpJourney />
                </PublicRoute>
              }
            />
            <Route
              path={routes.resetPassword}
              element={
                <PublicRoute>
                  <ResetPassword />
                </PublicRoute>
              }
            />
            <Route
              path={routes.userProfile}
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
            <Route path={routes.quibbleFlows} element={<WindmillFlows />} />
            <Route path={routes.quibbleFlow} element={<FlowDetail />} />
            <Route path={routes.quibbleFlowDetail} element={<JobDetail />} />
            <Route path={routes.mailVerify} element={<VerifyMail />} />
            <Route path={routes.acceptInvite} element={<AcceptInvite />} />
            <Route
              path={routes.callStage}
              element={
                <ProtectedRoute>
                  <CallStagesFlow />
                </ProtectedRoute>
              }
            />
            {/* Catch-all route for non-existent routes */}
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <RouteNotFound />
                </ProtectedRoute>
              }
            />
          </Routes>
        </DashboardProvider>
      </Suspense>
      <GlobalCallManager />
    </>
  );
}
